import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/mine/logoBg.png';

const _withScopeId = n => (_pushScopeId("data-v-13442017"), n = n(), _popScopeId(), n);

const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "error"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0
})], -1));

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "error"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0
})], -1));

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_image = _resolveComponent("van-image");

  return _openBlock(), _createBlock(_component_van_image, {
    "lazy-load": "",
    key: $setup.imgUrl,
    round: $props.round,
    src: $setup.imgUrl.startsWith('http') ? $setup.imgUrl : $setup.baseUrl.image_url + $setup.imgUrl
  }, {
    loading: _withCtx(() => [_hoisted_1]),
    error: _withCtx(() => [_hoisted_2]),
    _: 1
  }, 8, ["round", "src"]);
}